import React from 'react'

import SidebarResource from './SidebarResource'

import style from './Sidebar.module.scss'

const SidebarResources = ({ 
  resources,
  microcopy,
  location
}) => (
  <li className={style.tag}>
    <ul>
      <li>
        <h3>
          { microcopy.text('reference.titles.other_resources') }
        </h3>
      </li>
      { resources.map(resource => (
        <li key={ resource.id }>
          <SidebarResource 
            location={location}
            resource={ resource } />
        </li>
      ))}
    </ul>
  </li>
)

export default SidebarResources